import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import getCorso from "../../services/getCorso";
import getStudenti from "../../services/getStudenti";
import { NineCellLoading } from 'react-loadingg';
import Table from '../../widgets/tables/Table';
import getInsegnanti from '../../services/getInsegnanti';
import getEsami from "../../services/getEsami";
import checkUtente from "../../services/checkUtente";
import getMaterie from '../../services/getMaterie';
import InsertEsame from "../../widgets/InsertEsame";
import addEsame from "../../services/addEsame";
import deleteEsame from "../../services/deleteEsame";
import AdWidget from "../../widgets/AdWidget";
import translateString from "../../utils/Locales";
import getAllDocuments from "../../services/getAllDocuments";
import setActive from "../../services/setActive";


import UploadDocument from "../../widgets/UploadDocument";
import deleteDocument from "../../services/deleteDocument";
import getTestsInsegnante from "../../services/getTestsInsegnante";
import deleteTest from "../../services/deleteTest";

let t = translateString;

export default class TeacherEsami extends React.Component {

	constructor(props){
		super (props)
	
		this.pageDiv = {
			border: '1px solid #cccccc',
			padding: 10
		};
	
		this.section = this.props.section
		if (this.section == undefined){
			const pathname = props.location.pathname;
			this.section = pathname.substring(8, pathname.length);
		}

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined){
			this.pageName = this.section;
		}

		this.userslist = [];
		this.studenti = [];
		this.tests = [];

		this.grid = 2;

		this.pageTitle = "Valutazioni";
		this.startDateRef = React.createRef();
		this.endDateRef = React.createRef();
		const cookies = new Cookies();
		this.dbPath = cookies.get('db_path', { path: '/' });

		this.state = {
			details: [],
			insertEsameShow: false, 
			exams: [], 
			retiredDetails: '',
			isLoading: true
		};

	}

	async loadEsami(){
		const cookies = new Cookies();
		const username = cookies.get('username', { path: '/' });
		const token = cookies.get('token', { path: '/' });
		const currentCourse = cookies.get('currentCourse', { path: '/' });
		this.esami = await getEsami(username, token, this.corso.id);
		this.documents = await getAllDocuments(username, token, currentCourse);
		this.tests = await getTestsInsegnante(username, token, currentCourse);
		console.log(this.tests);
		this.esami = this.esami.filter((esame) => esame.id_insegnante === this.currUtente.id);
		this.esami.forEach((esame) => {
			esame.tipo = esame.type === '1' ? t('scritto') : t('orale');
			this.materie.forEach((materia) => {
					if (materia.id === esame.id_materia) {
						esame.materia = materia.materia;
					}
			}); 
			if (esame.materia === undefined) {
				esame.materia = '';
			}
		});
	}

	async loadComponent() {
		const cookies = new Cookies();
		const username = cookies.get('username', { path: '/' });
		const token = cookies.get('token', { path: '/' });
		const currentCourse = cookies.get('currentCourse', { path: '/' });

		this.utente = await checkUtente(username, token, username);
		this.corso = await getCorso(username, token, currentCourse);
		this.studenti = await getStudenti(username, token);
		this.insegnanti = await getInsegnanti(username, token);
		this.materie = await getMaterie(username, token);
		this.currUtente = this.insegnanti.filter((insegnante) => insegnante.id === this.utente[0].user_id)[0];
		await this.loadEsami();

		this.setState({corso: this.corso, isLoading: false, utente: this.currUtente });
	}

	async componentDidMount(){
		await this.loadComponent();
	}

	render () {
	
		var headCellsEsami = [
			{ id: 'data', numeric: true, disablePadding: false, label: t('data') },
			{ id: 'materia', numeric: false, disablePadding: true, label: t('materia') },
			{ id: 'tipo', numeric: false, disablePadding: true, label: t('tipologia') },
			{ id: 'nome', numeric: false, disablePadding: true, label: t('note') },
		];

		var headCellsDocumenti = [
			{ id: 'filename', numeric: false, disablePadding: false, label: t('file') },
			{ id: '_', numeric: true, disablePadding: false, label: '' }
		];

		var headCellsTests = [
			{ id: 'nome_esame', numeric: false, disablePadding: false, label: t('nome') },
			{ id: 'materia', numeric: false, disablePadding: false, label: t('materia') },
		];

		this.searchColsEsami = ['nome', 'tipo', 'materia'];
		this.searchColsDocumenti = ['filename', 'id_mittente'];
		this.searchColsTest = ['materia'];

		if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

		if (this.state.corso == undefined) return <div />;

		return (
			<>
			<LoadingOverlay
			active={this.state.isLoading}
			styles={{
				content: () => ({
					position: 'relative',
					width: '100%',
					top: '200px'
				})
			}}
			spinner
			text={'Loading your content...'}
			>
				<PageTitle title={t('tue_valutazioni')} button={t('aggiungi')} onClick={ () => this.setState({ insertEsameShow: true }) } />
					
				<Table headCells={headCellsEsami} searchCols={this.searchColsEsami} calendar={false} excel={false} pdf={false} rows={this.esami} 
					onDelete={(async (row) => {
							if(window.confirm(t('cancella_esame'))) {
									const cookies = new Cookies();
									const username = cookies.get('username', { path: '/' });
									const token = cookies.get('token', { path: '/' });
									const res = await deleteEsame(username, token, row);
									await this.loadEsami();
									this.setState({ });
							}
					})}

					onEventClick={(row) => {
						const cookies = new Cookies();
						cookies.set('currentEsame', row, { path: '/' });
						window.location.href =  '/' + this.dbPath + '/#/app/esameDetails';
				}}
				/> 

				{ this.state.insertEsameShow && (
				<InsertEsame key={Math.random()} 
					show={this.state.insertEsameShow}
					onCancel={() => this.setState({insertEsameShow: false})}
					insegnanteSet={true}
					insegnante={{ value: this.state.utente.id, label: (this.state.utente.cognome + ' ' + this.state.utente.nome) }}
					onOkClicked={async (id_insegnante, nome_insegnante, id_materia, data, titolo, type) => { 
						const cookies = new Cookies();
						const username = cookies.get('username', { path: '/' });
						const token = cookies.get('token', { path: '/' });

						this.setState({insertEsameShow: false});
						
						var resp = await addEsame(username, token, this.corso.id, id_insegnante, nome_insegnante, id_materia, data, titolo, type);
						await this.loadEsami();
						this.setState({});
						if (resp.result == 'ok') 
							alert (t('esame_inserito'));
						else 
							alert (t('errore_imprevisto'));
					}}
					/>
					)}
					<AdWidget bottomWidget={true} />

					
					{/*             DOCUMENTI             */}

					<PageTitle title={t('documenti')} button={t('aggiungi')} onClick={() => {
						this.setState({uploadDocumentShow: true})
						}}
					/>
					<Table headCells={headCellsDocumenti} searchCols={this.searchColsDocumenti} download={true} rows={this.documents} 

						onDelete={async (id) => {
							if (window.confirm(t('cancella_file')) == false) return;

							const cookies = new Cookies();
							const username = cookies.get('username', { path: '/' });
							const token = cookies.get('token', { path: '/' });    
							await deleteDocument(username, token, id);
							await this.loadEsami();
							this.setState({});
				
						}}
					/>
					{
						this.state.uploadDocumentShow && (
							<UploadDocument
								corso={this.state.corso}
								key={Math.random()}
								show={this.state.uploadDocumentShow}
								onClose={async () => {
									this.setState({ uploadDocumentShow: false });
									await this.loadEsami();
									this.setState({});
								}}
							/>
						)
					}
					
					{/*             ESAMI             */}

					<PageTitle title={t('esami')} button={t('aggiungi')} onClick={() => window.location.href =  '/' + this.dbPath + '/#/app/nuovoEsame'
						}
					/>
					<Table headCells={headCellsTests} searchCols={this.searchColsTest}  rows={this.tests} 

						onDelete={async (id) => {
							if (window.confirm(t('cancella_file')) == false) return;

							const cookies = new Cookies();
							const username = cookies.get('username', { path: '/' });
							const token = cookies.get('token', { path: '/' });    
							await deleteTest(username, token, id);
							await this.loadEsami();
							this.setState({});
						}}

						setActive={async (id) => {
							const cookies = new Cookies();
							const username = cookies.get('username', { path: '/' });
							const token = cookies.get('token', { path: '/' });    
							let test = this.tests.filter((t) => {
								return t.id === id
							})[0]
							let verificato = test.abilitato === "1" ? 0 : 1;
							
							setActive(username, token, id, verificato).then(el => {
							if (el.result === 'KO') {
								alert("no bueno")
							}
							});
							await this.loadEsami();
							this.setState({});
						}}

						onEventClick={(id) => {
							window.location.href =  '/' + this.dbPath + '/#/app/risultatiEsame?id=' + id
						}}

						onCopy={async (link) => {
							window.
							navigator.clipboard.writeText('https://' + window.location.hostname + link);
						}}
					/>

				</LoadingOverlay>
			</>
		);
	}

}

